'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const KeyboardKeys=require('../../../../dist-es6/client/common/keyboardKeys');

const _bindingDefaults={
inputId:Guid.create().toString(),
query:'',
label:'Search',
results:[],
selectedResult:null,
nextFormField:null,
showSelectedResult:!1,
fetchResultsFunction:function(){return[]}};


const _bindingDefaultKeys=_.keys(_bindingDefaults);let

TypeAheadController=(_class=function(_BaseController){_inherits(TypeAheadController,_BaseController);
function TypeAheadController($scope,$element,$timeout,uncaughtErrorHandler){_classCallCheck(this,TypeAheadController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout,$scope));
_this._$scope=$scope;
_this._$timeout=$timeout;
_this._$element=$element;
_this._previousSelections=[];

_.defaults(_this,_bindingDefaults);

_this.query='';

_this.showSelectedResult=!1;

_this._safeWatch('selectedResult',function(res){
_this._previousSelections=_.uniqWith(_this._previousSelections.concat(res),_.isEqual);
_this._moveToNextFormField();
});

_this._$timeout(function(){
_this.__autocompleteElement=angular.element(_this._$element).find('md-autocomplete input');

if(!_.exists(_this.__autocompleteElement)){
_this.showSelectedResult=!1;
return;
}

_this.__autocompleteElement.
on('focus',function(){return _this._$timeout(function(){return _this.showSelectedResult=!1})}).
on('blur',function(){return _this._$timeout(function(){return _this.showSelectedResult=!0})});
});return _this;
}TypeAheadController.prototype.

_moveToNextFormField=function _moveToNextFormField(){var _this2=this;
if(this.nextFormField){
this._$timeout(function(){
angular.element(_this2.nextFormField).focus();
});
}
};TypeAheadController.prototype.

hasVisited=function hasVisited(result){
return this._previousSelections.some(function(s){return _.isEqual(s,result)});
};TypeAheadController.prototype.


_safelyFetchResults=function(){var ref=_asyncToGenerator(function*(query){
try{
this.results=yield this.fetchResultsFunction(query);
}catch(err){
console.error(err);
return[];
}
return this.results;
});function _safelyFetchResults(query){return ref.apply(this,arguments)}return _safelyFetchResults}();TypeAheadController.prototype.

focusInputField=function focusInputField(fromDom){var _this3=this;
const inputElement=this.__autocompleteElement;
if(!_.exists(inputElement)){
return;
}

this._$timeout(function(){
angular.element(inputElement).focus();
_this3.showSelectedResult=!1;
});
};_createClass(TypeAheadController,[{key:'selectedResultIndex',get:function()

{
return this.results.indexOf(this.selectedResult);
}}]);return TypeAheadController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_safelyFetchResults',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_safelyFetchResults'),_class.prototype)),_class);let


TypeAheadDirective=function(_BaseControllerBacked){_inherits(TypeAheadDirective,_BaseControllerBacked);function TypeAheadDirective(){_classCallCheck(this,TypeAheadDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TypeAheadDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/typeAheadDirective/typeAheadTemplate'}},{key:'objectBindings',get:function()

{return _bindingDefaultKeys}},{key:'$inject',get:function()

{return['$scope','$element','$timeout','uncaughtErrorHandler']}},{key:'controller',get:function()

{return TypeAheadController}}]);return TypeAheadDirective}(BaseControllerBackedDirective);


module.exports=TypeAheadDirective;
//# sourceMappingURL=typeAheadDirective.js.map
